<ion-button 
  [disabled]="disabled || listening"
  (click)="onStartStop()"
  color="primary"
  fill="clear"
  class="speech-mic-btn">
  <ion-icon [name]="listening ? 'mic-off' : 'mic'"></ion-icon>
</ion-button>